'use client';

import { c as _c } from "react/compiler-runtime";
import { HugeiconsIcon, type HugeiconsIconProps } from '@hugeicons/react';
import type { Ref } from 'react';
import { cn } from '@/lib/ui/utils';
import { SOLID_BRAND_ICONS } from './brands';
import { SOLID_ICONS } from './glyphs';
export type IconProps = HugeiconsIconProps & {
  ref?: Ref<SVGSVGElement>;
};
export function Icon(t0) {
  const $ = _c(19);
  let className;
  let icon;
  let ref;
  let rest;
  let strokeWidth;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      strokeWidth,
      icon,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = icon;
    $[3] = ref;
    $[4] = rest;
    $[5] = strokeWidth;
  } else {
    className = $[1];
    icon = $[2];
    ref = $[3];
    rest = $[4];
    strokeWidth = $[5];
  }
  let t1;
  if ($[6] !== icon) {
    t1 = SOLID_ICONS.has(icon) || SOLID_BRAND_ICONS.has(icon);
    $[6] = icon;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const isSolid = t1;
  let t2;
  if ($[8] !== isSolid || $[9] !== strokeWidth) {
    t2 = isSolid ? {} : {
      strokeWidth: strokeWidth ?? 2
    };
    $[8] = isSolid;
    $[9] = strokeWidth;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const strokeWidthProps = t2;
  let t3;
  if ($[11] !== className) {
    t3 = cn("shrink-0", className);
    $[11] = className;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== icon || $[14] !== ref || $[15] !== rest || $[16] !== strokeWidthProps || $[17] !== t3) {
    t4 = <HugeiconsIcon ref={ref} icon={icon} className={t3} {...strokeWidthProps} {...rest} />;
    $[13] = icon;
    $[14] = ref;
    $[15] = rest;
    $[16] = strokeWidthProps;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}